import React from "react";

import { createRouteRef } from "@backstage/core-plugin-api";
import {
    ApiBlueprint,
    createApiFactory,
    createFrontendPlugin,
    discoveryApiRef,
    fetchApiRef,
    PageBlueprint,
} from "@backstage/frontend-plugin-api";

import { OneShotSqlClient, OneShotSqlRef } from "./apis";

export const rootRouteRef = createRouteRef({
    id: "oneshotsql",
});

export const OneshotsqlPage = PageBlueprint.make({
    params: {
        path: "/oneshotsql",
        routeRef: rootRouteRef,
        title: "OneShotSQL",
        loader: async () => {
            const m = await import("./components/OneShotSqlPage");
            return React.createElement(m.OneShotSqlPage);
        },
    },
});

/**
 * API extension that registers the OneShotSQL backend client.
 */
const oneShotSqlApiExt = ApiBlueprint.make({
    name: "oneshotsql",
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: OneShotSqlRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    fetchApi: fetchApiRef,
                },
                factory: ({ discoveryApi, fetchApi }) =>
                    new OneShotSqlClient({ discoveryApi, fetchApi }),
            })
        ),
});

/**
 * The OneShotSQL frontend plugin.
 */
const oneshotsqlFrontendPlugin = createFrontendPlugin({
    pluginId: "oneshotsql",
    extensions: [OneshotsqlPage, oneShotSqlApiExt],
});

export default oneshotsqlFrontendPlugin;
